module.exports = __webpack_public_path__ + "static/assets/70ffb90c7f312c1925404fcffe77925c.svg";